import Dropdown from 'rc-dropdown'
import 'rc-dropdown/assets/index.css'
import React, { CSSProperties, FC, ReactNode, useCallback, useEffect, useLayoutEffect, useReducer, useRef, useState } from 'react'
import Button from '../Button/Button'
import { CaretDownFill } from 'react-bootstrap-icons'

export type Option = {
  type: 'button' | 'label' | 'link',
  id: string
  label: string
  icon?: ReactNode
  to?: string
}

export interface BaseDropdownProps {
  options: Option[]
  children?: any
  baseTrigger?: React.ReactNode
  overlayStyle?: CSSProperties
  childOverlayStyle?: CSSProperties
  triggerStyle?: CSSProperties
  placement?: 'bottomCenter' | 'bottomRight' | 'bottomLeft'
  icon?: React.ReactNode,
  onSelect?: (option: Option) => any
  disabled?: boolean
  action?: 'hover' | 'click'
  activeId?: string
  selectedStyle?: CSSProperties
  onOverlayHeightChange?: (height: number) => any
}



export const BaseDropdown: FC<BaseDropdownProps> = ({
  options,
  children,
  overlayStyle = { 
    border: 'solid 1px #606470', 
    backgroundColor: '#fff',
    padding: '5px', 
    borderRadius: '5px',
  },
  childOverlayStyle = { 
    padding: '10px',
    cursor: 'pointer',
  },
  triggerStyle = {},
  placement = 'bottomCenter',
  icon=<CaretDownFill size={12}/>,
  onSelect = (option: Option) => {},
  disabled = false,
  action='click',
  activeId=undefined,
  selectedStyle={
    backgroundColor: '#40a9ff',
    color: '#fff',
    fontWeight: 'bold'
  },
  onOverlayHeightChange = (height: number) => undefined
}) => {
  const [selection, setSelection] = useState<string>()
  const [currOptions, setCurrOptions] = useState<Option[]>()

  useEffect(() => {
    if (!options) return

    setCurrOptions(options)
  }, [options])

  useEffect(() => {
    if (!activeId) return

    setSelection(activeId)
  }, [activeId])

  const renderItem = useCallback((o: Option) => {
    switch (o.type) {
      case 'link':
        return (
          <div 
          style={o.id == selection
            ? { ...childOverlayStyle, ...selectedStyle } 
            : childOverlayStyle}
            className='basedropdown-overlay-child'
            key={o.id} 
            tabIndex={0}
            role='button'
            onClick={(e: any) => {
              window.location.href = o.to
              setSelection(o.id)
            }}
          >
            {o.icon && <span
              style={{ marginRight: '5px' }}>{o.icon}</span>}
            {o.label}
         </div>
         )            
      case 'label':
        return (
         <div
          style={o.id == selection 
            ? { ...childOverlayStyle, ...selectedStyle } 
            : childOverlayStyle}
          key={o.id} 
          tabIndex={0}
          role='button'
          onClick={(e: any) => {
            onSelect(o)
            setSelection(o.id)
          }}
         >
          {o.icon && <span
            style={{ marginRight: '5px' }}
          >{o.icon}</span>}
          {o.label}
        </div>
        )      
      default:
        return (
         <Button
          style={o.id == selection
            ? { ...childOverlayStyle, ...selectedStyle } 
            : childOverlayStyle}
          key={o.id} 
          onClick={(e: any) => {
            onSelect(o)
            setSelection(o.id)
          }}
         >
          {o.icon}
          {o.label}
        </Button>
        )
    }
  }, [selection, currOptions])

  const ref = useRef<HTMLDivElement>(null)
  const [isVisible, setIsVisible] = useState(false)

  useEffect(() => {
    const element = ref?.current
    if (!element) return
    const observer = new ResizeObserver(() => {
      onOverlayHeightChange(ref?.current?.clientHeight)
    })
    observer.observe(element)
    return () => {
      observer.disconnect()
    }
  }, [isVisible])

  return (
    <div>
      {<div style={{ display: 'flex', flexDirection: 'row' }}>
        {children}
        <Dropdown
          trigger={[action]}
          overlayStyle={overlayStyle}
          placement={placement}
          onVisibleChange={setIsVisible}
          animation={'slide-up'}
          onOverlayClick={(e: Event) => {
            e.stopPropagation()
            setIsVisible(false)
          }}
          // @ts-ignore
          overlay={<div ref={ref}>
            {currOptions?.map(renderItem)}
          </div>}
        >
          <button
            disabled={disabled}
            className='poll-button' 
            style={triggerStyle}
            onClick={(e: any) => e.stopPropagation()}
            >
            {icon}
          </button>
        </Dropdown>
      </div>}
    </div>
  )
}